import { StatusTagProps } from '@myrealtrip/web-ui';

import type { TagCode } from '~models/Transportation/PointToPointTicket';
import type { PassRecommendationKey, PassSectionKey } from '~types/pass';

export const PASS_SECTION_KEY = {
  ALL: 'ALL',
  Europe: 'Europe',
  Switzerland: 'Switzerland',
  Italy: 'Italy',
  Germany: 'Germany',
  France: 'France',
} as const;

export const PASS_SECTION_TITLE: Record<PassSectionKey, string> = {
  ALL: '전체',
  Europe: '유럽',
  Switzerland: '스위스',
  Italy: '이탈리아',
  Germany: '독일',
  France: '프랑스',
} as const;

export const PASS_RECOMMENDATION_KEY = {
  SWISS: 'SWISS',
  EUROPE: 'EUROPE',
  EUROPE_REGIONAL: 'EUROPE_REGIONAL',
} as const;

export const PASS_RECOMMENDATION_TITLE: Record<PassRecommendationKey, string> = {
  SWISS: '스위스 패스',
  EUROPE: '유레일 패스',
  EUROPE_REGIONAL: '유레일 국가별 패스',
} as const;

type PassTagMap = {
  [key in TagCode]: {
    tint: StatusTagProps['tint'];
    variant: StatusTagProps['variant'];
  };
};

export const PASS_TAG_MAP: PassTagMap = {
  CONSECUTIVE: {
    tint: 'on',
    variant: 'green',
  },
  NON_CONSECUTIVE: {
    tint: 'on',
    variant: 'purple',
  },
  DAILY: {
    tint: 'off',
    variant: 'gray',
  },
} as const;

export const PASS_CARD_SECTION_DIVIDER_HEIGHT = 12;
